export default __webpack_public_path__ + "static/walletconnect-20aaf520bf702ee95e961a4dcec5e390.svg";